import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class PermissionService {

  private permissions: any = undefined;
  private subject = new Subject<any>();

  constructor(public http: HttpService) { }

  public fillPermissions() {
    this.http.pathRest().get('cartao/current/permissions/', true).
      subscribe(sucesso => {
        this.permissions = sucesso.json();
        this.subject.next(this.permissions);
      });
  }

  public onPermissionsChanged(): Observable<any> {
    return this.subject.asObservable();
  }

  public hasPermission(funcionalidade) {
    if (this.permissions) {
      for (let i = 0; i < this.permissions.length; i++) {
        if (this.permissions[i].permissao === funcionalidade) {
          return true;
        }
      }
    }

    return false;
  }

  public getPermissions() {
    return this.permissions;
  }

  public clean() {
    this.permissions = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/permission.service.ts